// add all the elements inside modal which you want to make focusable
const focusableElements =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
const modal = document.querySelector('.navbar_menu_items'); // select the modal by it's id

if (modal) {
  const humbuggerButton = document.querySelector('.navbar_left_button');
  const firstFocusableElement = humbuggerButton; // get first element to be focused inside modal
  const focusableContent = modal.querySelectorAll(focusableElements);
  const lastFocusableElement = focusableContent ? focusableContent[focusableContent.length - 1]: null;

  document.addEventListener('keydown', function (e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    const isHumbuggerOpened = document.querySelector('body').classList.contains('openHumbugger');
  
    if (!isHumbuggerOpened || !isTabPressed) {
      return;
    }
  
    if (e.shiftKey) {
      // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement && lastFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else {
      // if tab key is pressed
      if (document.activeElement === lastFocusableElement) {
        // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  });
}

